module.exports = __webpack_public_path__ + "img/DK28148321.030baa1c.png";